import { createContext } from 'react';

import menus from '@configs/menu.json';

const MenuValues = menus;

const MenuContext = createContext(MenuValues);

export default MenuContext;
export { MenuValues };